import { createContext, useContext, useState } from 'react';

const FinanceContext = createContext(null);

export const FinanceProvider = ({ children }) => {
  const [activeTab, setActiveTab] = useState(1);

  return (
    <FinanceContext.Provider value={{ activeTab, setActiveTab }}>
      {children}
    </FinanceContext.Provider>
  );
};

export const useFinance = () => {
  const context = useContext(FinanceContext);
  if (!context) {
    throw new Error('useFinance must be used within FinanceProvider');
  }
  return context;
};
